import { useFormikContext } from 'formik';
import { useEffect } from 'react';

type BindSubmit = (submit: (() => Promise<void> | void) | null) => void;

/** Registers Formik submitForm with parent Modal.handlerSubmit */
export const FormSubmitBinder = ({ onBind }: { onBind: BindSubmit }) => {
    const { submitForm } = useFormikContext();

    useEffect(() => {
        onBind(() => submitForm());

        return () => onBind(null);
    }, [onBind, submitForm]);

    return null;
};
